import React, { useEffect, useState } from 'react'

import { UserProfileRole } from '../modules/users/types/UserProfile'
import { AppPath } from '../enums/AppPath'
import { useAuth } from '../hooks/useAuth'

import { ButtonAction, ButtonMenuSet } from './Buttons'
import DocAnula from './DocAnula'

const SubMenuPurchase: React.FC<{
  handleGoBackEdit: () => void
  handleAnular?: (motivo: string) => void
  esAnulada: boolean
}> = ({ handleGoBackEdit, handleAnular, esAnulada }) => {
  const [clickedIndex, setClickedIndex] = useState<number>(-1)
  const [motivo, setMotivo] = useState<string>('')
  const { hasRole } = useAuth()

  const handleMenuClick = (index: number) => {
    setClickedIndex(index)
  }

  const handleAnularClick = () => {
    handleAnular && handleAnular(motivo)
  }

  const handleMotivoChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setMotivo(e.target.value)
  }

  useEffect(() => {
    // Scroll to bottom when menu changes
    window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' })
  }, [clickedIndex])

  const modificarCaption = hasRole(UserProfileRole.ModifyPurchases) ? 'Modificar' : ''
  const anularCaption = hasRole(UserProfileRole.VoidPurchases) ? 'Anular' : ''

  const buttonCaptions = [modificarCaption, anularCaption]

  return (
    <div className="p-2 max-w-3xl mx-auto shadow-md border">
      <ButtonMenuSet captions={buttonCaptions} clickedIndex={clickedIndex} handleButtonClick={handleMenuClick} />
      <div className="mt-4">
        {clickedIndex === 0 && !esAnulada && (
          <>
            <div>
              Podrás modificar los datos de esta nota de compra, excepto el cliente y el vehículo. Si deseas
              modificarlos, debes anular esta nota de compra y crear otra.
            </div>
            <div className="flex justify-center mt-4">
              <ButtonAction label="Ir a modificar" handleButtonClick={handleGoBackEdit} />
            </div>
          </>
        )}
        {clickedIndex === 1 && !esAnulada && (
          <DocAnula
            label="Motivo de anulación"
            header={'Al anular la nota de compra esta ya no será legalmente válida.'}
            name="motivo"
            value={motivo}
            docType={AppPath.Settlements}
            handleInputChange={handleMotivoChange}
            handleButtonClick={handleAnularClick}
          />
        )}
      </div>
    </div>
  )
}

export default SubMenuPurchase
